import React from 'react'

import './CustomerAddressValidationMessage.scss'

function CustomerAddressValidationMessage ({ suggestion = {} as any }) {
  let message = ''

  const street = suggestion?.data?.street_with_type ?? null
  const house = suggestion?.data?.house ?? null

  if (!house) {
    message = 'Укажите номер дома'
  }

  if (!street) {
    message = 'Укажите улицу и номер дома'
  }

  return <div className="CustomerAddressValidationMessage">{message}</div>
}

export default React.memo(CustomerAddressValidationMessage)
